import { PropsWithChildren } from 'react';

import { LoadingContext } from './context';

type Props = PropsWithChildren<{ isLoading?: boolean }>;

export const LoadingProvider = ({ isLoading, children }: Props) => {
  return (
    <LoadingContext.Provider value={isLoading}>
      {children}
    </LoadingContext.Provider>
  );
};
